module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\r\n    <h3 class="center">Vitals</h3>\r\n    ';
 if (canEdit) { 
__p+='\r\n    <div class="left-buttons">\r\n        <button type="button" class="btn btn-success" id="add">Add vital</button>\r\n    </div>\r\n    ';
 } 
__p+='\r\n    <div class="top-margined">\r\n        <table class="table table-hover">\r\n            <thead>\r\n            <tr>\r\n                <th>Created time</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody></tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n\r\n<div id="vital-form"></div>\r\n<div id="delete-confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/medicals/patient-vitals.html
// module id = 385
// module chunks = 0